export const resolutionList = [
  // ['auto', 0, 0, 0, 'auto'],
  // null,
  ['tick', 0.001, 7, 1, 'tick'],
  null,
  ['1 second', 1, 0, 1, '1s'],
  ['5 seconds', 5, 0, 5, '5s'],
  ['15 seconds', 15, 0, 15, '15s'],
  ['30 seconds', 30, 0, 30, '30s'],
  null,
  ['1 minute', 60, 1, 1, '1m'],
  ['5 minutes', 300, 1, 5, '5m'],
  ['15 minutes', 900, 1, 15, '15m'],
  ['30 minutes', 1800, 1, 30, '30m'],
  null,
  ['1 hour', 3600, 2, 1, '1h'],
  ['1 day', 86400, 3, 1, '1d'],
  ['1 week', 604800, 4, 1, '1w'],
  ['1 month', 2592000, 5, 1, '1m'],
  ['1 year', 31557600, 6, 1, '1y']
];


// WEBPACK FOOTER //
// ./src/core/constants/resolutions.js